import { render, staticRenderFns } from "./PurchaseTable.vue?vue&type=template&id=454e9834&scoped=true&"
import script from "./PurchaseTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e9834",
  null
  
)

export default component.exports